export default __webpack_public_path__ + "static/media/earn.19d5cf86.svg";